import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const fetch = async (query: { SalesOrder: string; LineNumber: number; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { Page, SalesOrder, LineNumber, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `SalesOrderEnquiry/SalesOrder/${SalesOrder}/Line/${LineNumber}/LineCommitments/ProductionOrders`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        SalesOrderCommittedProductionOrder: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.SalesOrderCommittedProductionOrder) {

            return {
              records: result.SalesOrderCommittedProductionOrder.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
